import { HomeOutlined } from "@ant-design/icons";
import {
  Edit,
  LiveHelp,
  Notifications,
  PersonOutlined,
  Analytics,
  Logout,
  SentimentSatisfiedAlt,
} from "@mui/icons-material";
import type { MenuProps } from "antd";

export default function MenuData() {
  const items: MenuProps["items"] = [
    {
      key: "",
      label: "홈",
      icon: <HomeOutlined />,
    },
    {
      key: "MemberPage",
      label: "직원관리",
      icon: <PersonOutlined />,
    },
    {
      key: "CustomersPage",
      label: "고객관리",
      icon: <SentimentSatisfiedAlt />,
    },
    {
      key: "QuestionPage",
      label: "질문관리",
      icon: <LiveHelp />,
    },
    {
      key: "NoticePage",
      label: "공지사항관리",
      icon: <Notifications />,
    },
    {
      key: "ConsultPage",
      label: "컨설팅결과관리",
      icon: <Edit />,
    },
    {
      key: "ResultPage",
      label: "통계관리",
      icon: <Analytics />,
      children: [
        {
          key: "CustomerResultPage",
          label: "고객통계",
        },
        {
          key: "ColorConsultResultPage",
          label: "컬러컨설팅통계",
        },
        {
          key: "FitConsultResultPage",
          label: "체형 & 얼굴 컨설팅통계",
        },
      ],
    },
    {
      key: "logout",
      label: "로그아웃",
      icon: <Logout />,
    },
  ];

  return items;
}
